import React, { useRef, useState } from 'react';
import { ProviderMessaging } from './messaging';
import { MessagingPresenter } from './messaging.presenter';

export interface IMessagingContextProps {
    claimId?: string;
    guarantorId?: string;
    isComposeOpen?: boolean;
    messageId?: string;
    defaultSubject?: string;
    defaultBody?: string;
    onAssignDocument?: () => void;
}

export interface IProviderMessagingContextProps {
    openPanel: ((props: IMessagingContextProps) => void) | undefined;
    closePanel: (() => void) | undefined;
}

export const ProviderMessagingContext = React.createContext<IProviderMessagingContextProps>({
    openPanel: undefined,
    closePanel: undefined,
});

export const ProviderMessagingProvider: React.FC<{ children?: React.ReactNode }> = ({ children }): React.ReactElement => {
    const [contextProps, setContextProps] = useState<IMessagingContextProps>();
    const { current: presenter } = useRef(new MessagingPresenter());

    const openPanel = (props: IMessagingContextProps): void => {
        presenter.setOpen(true);
        if (props.messageId) {
            presenter.openMessage(props.messageId);
        }

        if (props.isComposeOpen) {
            presenter.setComposeOpen(props.isComposeOpen);
        }

        setContextProps(props);
    };

    const closePanel = (): void => {
        presenter.setOpen(false);
        setContextProps(undefined);
    };

    return (
        <ProviderMessagingContext.Provider value={{ openPanel, closePanel }}>
            {children}
            {contextProps && (
                <ProviderMessaging
                    presenter={presenter}
                    claimId={contextProps.claimId}
                    guarantorId={contextProps.guarantorId}
                    messageId={contextProps.messageId}
                    defaultBody={contextProps.defaultBody}
                    defaultSubject={contextProps.defaultSubject}
                    onAssignDocument={contextProps.onAssignDocument}
                    onClose={closePanel}
                />
            )}
        </ProviderMessagingContext.Provider>
    );
};
